<template>
  <el-dialog
  title="提交外出及刷卡异常"
  :visible.sync="show"
  :before-close="close"
  center>
    <div v-if="type !== 'new'" class="text-row">申请人：{{applyUser}}</div>
    <el-row style="max-height:500px;overflow-y: auto;">
      <table-list
    :data="ListData"
    :showPagination="false"
    :columnDefs="columnDefs">
      <template #remark={row}>
        <el-input v-model="row.remark" :disabled="type !== 'new'"/>
      </template>
      </table-list>
      <el-form
      ref="form"
      :rules="rules"
      style="margin:20px 0"
      :model="info"
      label-position="left"
      label-width="35%">
      <el-col :span="12" v-if="type === 'examine'">
          <el-form-item label="审核状态">
              <el-select v-model="examine" @change="handleRemark" :disabled="type == 'new'">
                  <el-option :value="item.value" :label="item.label"  v-for="(item,index) in statusOptions" :key="index"/>
              </el-select>
          </el-form-item>
          <el-form-item
          label="审核原因"
          >
            <el-input
            type="textarea"
            :rows="5"
            maxlength="200"
            show-word-limit
            placeholder="请输入审核原因"
            @input="changeMessage($event)"
            :disabled="type == 'new'"
            v-model="info.remark"/>
          </el-form-item>
      </el-col>
      <el-col :span="24">
        <template v-if="type === 'new' || examine === 0">
            <el-col :span="24">
              <approvalRadio  v-model="isSubmitApproval" /></el-col>
            <el-col :span="23">
              <el-form-item label="下一级审核人" prop="auditPersonId" v-if="activeName == 'queryMine'">
                <el-select v-model="info.auditPersonId" placeholder="请选择" clearable filterable :disabled="type !== 'new'">
                  <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
      </el-col>
      <el-col :span="24">
        <template v-if="activeName == 'queryMyAudit' || type === 'examine'">
            <el-col :span="24">
              <el-form-item label="是否结束审核" prop="lastUserFlag" v-if="examine == '1'">
                <el-radio v-model="info.lastUserFlag" :label="1">是</el-radio>
                <el-radio v-model="info.lastUserFlag" :label="0">否</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <approvalRadio  v-model="isSubmitApproval" v-show="examine == '1' && info.lastUserFlag == 0"/>
            </el-col>
            <el-col :span="24">
              <el-form-item label="下一级审核人" prop="nextAuditUserName" v-if="examine == '1' && info.lastUserFlag == 0">
                <el-select v-model="info.nextAuditUserName" placeholder="请选择" clearable filterable>
                  <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <approvalRadio  v-model="isSubmitApproval" v-show="examine == '3'"/>
            </el-col>
            <el-col :span="24">
              <el-form-item label="转办人" prop="nextAuditUserName" v-if="examine == '3'">
                <el-select v-model="info.nextAuditUserName" placeholder="请选择" clearable filterable>
                  <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
        </template>
      </el-col>
        <el-col :span="24" v-if="type === 'examine' || type === 'details'">
        <div v-if="type !== 'new'">
        <div class="text-row">审核人：{{auditPerson || preAuditPerson}}</div>
        <div class="text-row">审核状态：{{status | getAuditName}}</div>
        <!-- TODO 审核记录 -->
        <review-process
        :processList="reviewedList"
        :createTime="createTime"
        :createUser="applyUser"
        :auditPerson="auditPerson"
        />
      </div>
      </el-col>
      </el-form>
    </el-row>
    
    <div slot="footer">
      <el-button type="primary" @click="stagingApplyIng" v-if="(type === 'new' && status === 10) || (type === 'new' && status === '') ">暂 存</el-button>
      <el-button type="primary" @click="submit" v-if="type === 'new'">提 交</el-button>
      <el-button type="primary" @click="examineFn" v-else-if="type === 'examine'">提 交</el-button>
      <el-button @click="close">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableList from '@/components/TableList.vue'
import { submitAttendanceApply, getApplyDetail, auditAndNextUser, stagingApply } from '@/api/compAttendance.js'
import { ApprovalStatus } from '@/utils/constants'
import ReviewProcess from '@/components/ReviewProcess.vue'
// import { queryUserInfo } from '@/api/basicInfo'
import approval from '@/mixins/approval'
export default {
  mixins: [approval],
  data () {
    return {
      show: false,
      activeName: 'queryMine',
      ListData: [],
      columnDefs: [
        { label: '打卡日期', prop: 'checkDate', width: 100 },
        { label: '上班时间', prop: 'arrivalTime', width: 100 },
        { label: '下班时间', prop: 'leaveTime', width: 100 },
        { label: '异常原因', prop: 'remark' },
      ],
      id: '',
      eventId: '',
      applyReason: '',
      type: '',
      loading: false,
      actionType: '',
      applyUser: '', // 申请人
      auditPerson: '', // 审核人
      preAuditPerson: '',
      status: '', // 审核状态
      reviewedList: [], // 审批记录
      createTime: '', // 申请创建时间
      examine: '', // 审批状态
      statusOptions: [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
        {
          value: '4',
          label: '退回上一级'
        },
      ],
      info: {
        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',
        remark: '',
      },
      // userInfoList: [],
      rules: {
        nextAuditUserName: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        auditPersonId: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        lastUserFlag: [{ required: true, message: '请选择是否结束审核', trigger: 'change' }],
      },
    }
  },
  filters: {
    getAuditName (value) {
      let status = ApprovalStatus.find(item => item.value === value)
      return status?.label || ''
    }
  },
  components: {
    TableList,
    ReviewProcess
  },
  mounted() {
    this.queryList()
  },
  methods: {
    handleStatus(creatUser) {
     let userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName
     if (userName === creatUser) {
      this.statusOptions = [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
      ]
     }
    },
    handleRemark(val) {
      if (val === '1') {
        this.info.remark = '同意'
      } else if (val === '3') {
        this.info.remark = '转办'
      } else {
        this.info.remark = ''
      }
    },
    changeMessage() {
      this.$forceUpdate()
    },
    // async queryList() {
    //         let res = await queryUserInfo({
    //             pageNum: 1,
    //             pageSize: 9999,
    //         })
    //         if (res.code === 0) {
    //             this.userInfoList = res.result.records
    //         }
    //     },
    showDialog (type = 'new', data, activeName) {
      this.type = type
      this.activeName = activeName
      this.show = true
      if (type === 'new') {
        this.ListData = data.map((item) => {
          return {
            checkDate: item.checkDate,
            arrivalTime: item.arrivalTime,
            leaveTime: item.leaveTime,
            remark: '',
            id: item.id,
          }
        })
      } else {
        this.getDetails(data)
      }
    },
    getDetails (id) {
      this.id = id
      this.loading = true
      getApplyDetail({
        id
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.eventId = result.eventId
        this.applyReason = result.applyReason
        this.applyUser = result.applyUser
        this.auditPerson = result.auditPerson
        this.auditPersonId = result.auditPersonId
        this.preAuditPerson = result.preAuditPerson
        this.createTime = result.createTime
        this.reviewedList = result.auditProcessEntityList
        this.status = result.status
        this.ListData = result.attendanceGetDetailRespList
        this.info.auditPersonId = result.auditPersonId
        this.handleStatus(result.createUser)
        if (this.type === 'new' && this.info && this.info.auditPersonId && result.status === 10) {
          this.info.auditPersonId = ''
        }
      })
    },
    close () {
      this.show = false
      this.applyUser = '' // 申请人
      this.reviewedNmae = '' // 审核人
      this.reviewedType = '' // 审核状态
      this.reviewedList = [] // 审批记录
      this.createTime = ''
      this.ListData = []
      this.examine = ''
      this.applyReason = ''
      this.info.remark = ''
    },
    submit () {
      this.$refs.form.validate(async(vaild) => {
        if (vaild) {
          if (this.actionType === 'new') {
            submitAttendanceApply(
              {
                entityList: this.ListData.map((item) => {
                  return {
                    attendanceId: item.id,
                    remark: item.remark
                  }
                }),
                applyAttendanceEntity: {
                  auditPersonId: this.info.auditPersonId,
                }
              }
            ).then(res => {
              const { code } = res
              if (code !== 0) return
              this.$emit('query')
              this.close()
            })
          }
          if (this.actionType === 'update') {
            submitAttendanceApply(
            {
              
              entityList: this.ListData.map((item) => {
                return {
                  attendanceId: item.id,
                  remark: item.remark,
                  id: item.relationId,
                }
              }),
              applyAttendanceEntity: {
                auditPersonId: this.info.auditPersonId,
                id: this.id,
                eventId: this.eventId,
              }
            }
          ).then(res => {
            const { code } = res
            if (code !== 0) return
            this.$emit('query')
            this.close()
          })
          }
        }
      })
    },
    examineFn () {
      if (!this.examine) return this.$message.warning('请选择审核状态')
      this.$refs.form.validate(async(vaild) => {
        if (vaild) {
          auditAndNextUser({
              id: this.id,
              status: this.examine,
              lastUserFlag: this.info.lastUserFlag,
              nextAuditUserName: this.info.nextAuditUserName,
              remark: this.info.remark,
          }).then(res => {
            const { code } = res
            if (code !== 0) return
            this.$message.success('提交成功！')
            this.$emit('query')
            this.close()
          })
        }
      })
    },
    stagingApplyIng() {
      this.$refs.form.validate(async(vaild) => {
        if (vaild) {
          stagingApply(
            {
              entityList: this.ListData.map((item) => {
                return {
                  attendanceId: item.id,
                  remark: item.remark,
                }
              }),
              applyAttendanceEntity: {
                auditPersonId: this.info.auditPersonId,
                eventId: this.eventId,
              }
            }
          ).then(res => {
            const { code } = res
            if (code !== 0) return
            this.$emit('query')
            this.close()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog{
  min-width: 700px;
  width: 30%;
}
.text-row {
  line-height: 30px;
}
</style>
